import React from 'react';

import { Container } from 'styles/components/ErrorMessage';

const ErrorMessage = ({ children, className }) => (
  <Container className={className}>{children}</Container>
);

export default ErrorMessage;
